<p class="inline text-bold text-left page-title">Manage NCS Constituents:</p>

<div class="row" style="margin-top: 38px; width: 96%; margin-left: 14px;">
    <tab-container>
        <ng-template tab-pane [canDeactivate]="canDeactivate()" title="NCS Constituent Uploads">
            <div style="border: 2px solid #B0C4DE; padding-bottom: 20px;">
                <ncs-upload #self style="display: block; margin-left: 8px;" (stateChange)="ncsEventHandler($event)"></ncs-upload>
            </div>
        </ng-template>
        <ng-template tab-pane [canDeactivate]="canDeactivate()" title="NCS Constituent View/Edit">
            <div style="margin-bottom:12px; border: 2px solid #B0C4DE; padding-bottom: 40px;">
                <ncs-viewer #self style="display: block; margin-left: 8px;" ></ncs-viewer>
            </div>
        </ng-template>
    </tab-container>
</div>
